import type { LocaleMessageBundle } from '../../types'

export const contractMessages: LocaleMessageBundle = {
  vi: {
    'staff.contract.title': 'Quản lý hợp đồng lao động',
    'staff.contract.create': 'Thêm hợp đồng',
    'staff.contract.edit': 'Cập nhật hợp đồng',
    'staff.contract.detail': 'Chi tiết hợp đồng',
    'staff.contract.detailInformation': 'Thông tin hợp đồng',
    'staff.contract.viewDetails': 'Xem chi tiết',
    'staff.contract.downloadTemplate': 'Tải mẫu hợp đồng',
    'staff.contract.notifications.createSuccess': 'Thêm hợp đồng lao động thành công.',
    'staff.contract.notifications.updateSuccess': 'Cập nhật hợp đồng lao động thành công.',
    'staff.contract.notifications.deleteSuccess': 'Xóa hợp đồng lao động thành công.',
    'staff.contract.notifications.sendSuccess': 'Gửi hợp đồng đi duyệt thành công.',
    'staff.contract.notifications.approveSuccess': 'Duyệt hợp đồng thành công.',
    'staff.contract.notifications.rejectSuccess': 'Từ chối hợp đồng thành công.',
    'staff.contract.notifications.signSuccess': 'Ký hợp đồng thành công.',
    'staff.contract.notifications.renewSuccess': 'Gia hạn hợp đồng thành công.',
    'staff.contract.notifications.terminateSuccess': 'Chấm dứt hợp đồng thành công.',
    'staff.contract.code': 'Mã hợp đồng',
    'staff.contract.codeAutoGenerated': 'Mã hợp đồng sẽ được hệ thống tự tạo khi gia hạn.',
    'staff.contract.codeHint': 'Để trống để hệ thống tự sinh mã',
    'staff.contract.staff': 'Nhân viên',
    'staff.contract.type': 'Loại hợp đồng',
    'staff.contract.titleField': 'Tên hợp đồng',
    'staff.contract.jobTitle': 'Chức danh',
    'staff.contract.workLocation': 'Địa điểm làm việc',
    'staff.contract.branch': 'Chi nhánh',
    'staff.contract.startDate': 'Ngày bắt đầu',
    'staff.contract.endDate': 'Ngày kết thúc',
    'staff.contract.effectiveDate': 'Ngày hiệu lực',
    'staff.contract.salaryAmount': 'Mức lương',
    'staff.contract.salaryCurrency': 'Tiền tệ',
    'staff.contract.salaryPeriod': 'Kỳ lương',
    'staff.contract.salaryPeriod.MONTH': 'Theo tháng',
    'staff.contract.salaryPeriod.DAY': 'Theo ngày',
    'staff.contract.salaryPeriod.HOUR': 'Theo giờ',
    'staff.contract.search': 'Tìm mã hợp đồng',
    'staff.contract.sendForApproval': 'Gửi duyệt',
    'staff.contract.sendConfirm': 'Bạn có chắc muốn gửi hợp đồng này đi duyệt?',
    'staff.contract.approve': 'Duyệt hợp đồng',
    'staff.contract.approveConfirm': 'Bạn có chắc muốn duyệt hợp đồng này?',
    'staff.contract.reject': 'Từ chối hợp đồng',
    'staff.contract.rejectReason': 'Lý do từ chối',
    'staff.contract.sign': 'Ký hợp đồng',
    'staff.contract.signConfirm': 'Bạn có chắc muốn ký hợp đồng này?',
    'staff.contract.signFile': 'Tài liệu đã ký',
    'staff.contract.signFileHint': 'Không bắt buộc. Hỗ trợ PDF, Word, Excel, ảnh; tối đa {max}MB.',
    'staff.contract.signFileSelect': 'Chọn file',
    'staff.contract.signFileReplace': 'Đổi file',
    'staff.contract.signFileClear': 'Bỏ file',
    'staff.contract.signFileTooLarge': 'File vượt quá {max}MB',
    'staff.contract.signFileInvalidType': 'Định dạng file không được hỗ trợ',
    'staff.contract.signFileUploadFailed': 'Tải file lên thất bại, vui lòng thử lại',
    'staff.contract.renew': 'Gia hạn hợp đồng',
    'staff.contract.renewConfirm': 'Bạn có chắc muốn gia hạn hợp đồng này?',
    'staff.contract.terminate': 'Chấm dứt hợp đồng',
    'staff.contract.terminateConfirm':
      'Bạn có chắc muốn chấm dứt hợp đồng này? Nhân viên sẽ chuyển sang trạng thái tạm ngưng.',
    'staff.contract.terminateReason': 'Lý do chấm dứt',
    'staff.contract.terminateReasonPlaceholder': 'Nhập lý do chấm dứt',
    'staff.contract.deleteConfirm': 'Bạn có chắc muốn xóa hợp đồng nháp này?',
    'staff.contract.history': 'Lịch sử hợp đồng',
    'staff.contract.historyEmpty': 'Chưa có lịch sử cho hợp đồng này.',
    'staff.contract.historyFile': 'Tài liệu đính kèm',
    'staff.contract.historyFilePreview': 'Xem tài liệu',
    'staff.contract.historyFileOpen': 'Mở tab mới',
    'staff.contract.historyFileDownload': 'Tải tài liệu',
    'staff.contract.historyFileUnavailable': 'Tài liệu chưa sẵn sàng để xem.',
    'staff.contract.historyFilePreviewUnsupported':
      'Không hỗ trợ xem trước định dạng này. Vui lòng mở hoặc tải tài liệu.',
    'staff.contract.documentsTitle': 'Tài liệu hợp đồng',
    'staff.contract.documentsLoading': 'Đang tải tài liệu...',
    'staff.contract.documentsLoadFailed': 'Không tải được tài liệu hợp đồng.',
    'staff.contract.documentsEmpty': 'Hợp đồng này chưa có tài liệu được tải lên.',
    'staff.contract.documentType.draft': 'Bản dự thảo',
    'staff.contract.documentType.signed': 'Tài liệu đã ký',
    'staff.contract.documentType.addendum': 'Phụ lục hợp đồng',
    'staff.contract.documentType.termination': 'Tài liệu chấm dứt',
    'staff.contract.eventTypes.created': 'Tạo hợp đồng',
    'staff.contract.eventTypes.sent': 'Gửi duyệt',
    'staff.contract.eventTypes.approved': 'Duyệt',
    'staff.contract.eventTypes.rejected': 'Từ chối',
    'staff.contract.eventTypes.signed': 'Ký hợp đồng',
    'staff.contract.eventTypes.renewed': 'Tái ký',
    'staff.contract.eventTypes.terminated': 'Chấm dứt',
    'staff.contract.eventTypes.updated': 'Cập nhật',
    'staff.contract.status.all': 'Tất cả',
    'staff.contract.status': 'Trạng thái',
    'staff.contract.status.DRAFT': 'Bản nháp',
    'staff.contract.status.PENDING_APPROVAL': 'Chờ duyệt',
    'staff.contract.status.APPROVED': 'Đã duyệt',
    'staff.contract.status.REJECTED': 'Từ chối',
    'staff.contract.status.PENDING_SIGNATURE': 'Chờ ký',
    'staff.contract.status.SIGNED': 'Đã ký',
    'staff.contract.status.CANCELLED': 'Đã hủy',
    'staff.contract.status.EXPIRED': 'Hết hiệu lực',
    'staff.contract.status.TERMINATED': 'Đã chấm dứt',
    'staff.contract.errors.notTerminable':
      'Chỉ có thể chấm dứt hợp đồng mới nhất chưa được gia hạn.',
    'staff.contract.errors.notRenewable': 'Hợp đồng này không thể gia hạn.',
    'staff.contract.types.title': 'Quản lý loại hợp đồng',
    'staff.contract.types.create': 'Thêm loại hợp đồng',
    'staff.contract.types.edit': 'Cập nhật loại hợp đồng',
    'staff.contract.types.notifications.createSuccess': 'Thêm loại hợp đồng thành công.',
    'staff.contract.types.notifications.updateSuccess': 'Cập nhật loại hợp đồng thành công.',
    'staff.contract.types.notifications.deleteSuccess': 'Xóa loại hợp đồng thành công.',
    'staff.contract.types.notifications.deleteFailed': 'Xóa loại hợp đồng không thành công.',
    'staff.contract.types.code': 'Mã loại hợp đồng',
    'staff.contract.types.codeHint': 'Để trống để hệ thống tự sinh mã CTT001',
    'staff.contract.types.name': 'Tên loại hợp đồng',
    'staff.contract.types.description': 'Mô tả',
    'staff.contract.types.term': 'Thời hạn',
    'staff.contract.types.month': 'tháng',
    'staff.contract.types.months': 'tháng',
    'staff.contract.types.duration': 'Thời hạn mặc định (tháng)',
    'staff.contract.types.indefinite': 'Không xác định thời hạn',
    'staff.contract.types.active': 'Đang hoạt động',
    'staff.contract.typeStatus.active': 'Hoạt động',
    'staff.contract.typeStatus.inactive': 'Tạm ngưng',
    'staff.contract.types.status': 'Trạng thái',
    'staff.contract.types.sortOrder': 'Thứ tự sắp xếp',
    'staff.contract.types.filterSearch': 'Tìm mã hoặc tên',
    'staff.contract.types.filterSearchPlaceholder': 'Nhập mã hoặc tên loại hợp đồng',
    'staff.contract.types.termIndefinite': 'Không thời hạn',
    'staff.contract.types.termFixed': 'Có thời hạn',
    'staff.contract.types.actions': 'Thao tác',
    'staff.contract.types.deleteConfirm': 'Bạn có chắc muốn xóa loại hợp đồng này?',
    'staff.contract.types.inUse': 'Không thể xóa loại hợp đồng đang được sử dụng.',
    'staff.contract.types.inUseNamed': 'Loại hợp đồng {name} đang sử dụng.',
  },
  en: {
    'staff.contract.title': 'Labor contract management',
    'staff.contract.create': 'Add contract',
    'staff.contract.edit': 'Update contract',
    'staff.contract.detail': 'Contract details',
    'staff.contract.detailInformation': 'Contract information',
    'staff.contract.viewDetails': 'View details',
    'staff.contract.downloadTemplate': 'Download contract template',
    'staff.contract.notifications.createSuccess': 'Labor contract added successfully.',
    'staff.contract.notifications.updateSuccess': 'Labor contract updated successfully.',
    'staff.contract.notifications.deleteSuccess': 'Labor contract deleted successfully.',
    'staff.contract.notifications.sendSuccess': 'Labor contract sent for approval successfully.',
    'staff.contract.notifications.approveSuccess': 'Labor contract approved successfully.',
    'staff.contract.notifications.rejectSuccess': 'Labor contract rejected successfully.',
    'staff.contract.notifications.signSuccess': 'Labor contract signed successfully.',
    'staff.contract.notifications.renewSuccess': 'Labor contract renewed successfully.',
    'staff.contract.notifications.terminateSuccess': 'Labor contract terminated successfully.',
    'staff.contract.code': 'Contract code',
    'staff.contract.codeAutoGenerated': 'The contract code will be generated automatically when renewing.',
    'staff.contract.codeHint': 'Leave blank to generate automatically',
    'staff.contract.staff': 'Employee',
    'staff.contract.type': 'Contract type',
    'staff.contract.titleField': 'Contract title',
    'staff.contract.jobTitle': 'Job title',
    'staff.contract.workLocation': 'Work location',
    'staff.contract.branch': 'Branch',
    'staff.contract.startDate': 'Start date',
    'staff.contract.endDate': 'End date',
    'staff.contract.effectiveDate': 'Effective date',
    'staff.contract.salaryAmount': 'Salary amount',
    'staff.contract.salaryCurrency': 'Currency',
    'staff.contract.salaryPeriod': 'Salary period',
    'staff.contract.salaryPeriod.MONTH': 'Monthly',
    'staff.contract.salaryPeriod.DAY': 'Daily',
    'staff.contract.salaryPeriod.HOUR': 'Hourly',
    'staff.contract.search': 'Search contract code',
    'staff.contract.sendForApproval': 'Send for approval',
    'staff.contract.sendConfirm': 'Are you sure you want to send this contract for approval?',
    'staff.contract.approve': 'Approve contract',
    'staff.contract.approveConfirm': 'Are you sure you want to approve this contract?',
    'staff.contract.reject': 'Reject contract',
    'staff.contract.rejectReason': 'Rejection reason',
    'staff.contract.sign': 'Sign contract',
    'staff.contract.signConfirm': 'Are you sure you want to sign this contract?',
    'staff.contract.signFile': 'Signed document',
    'staff.contract.signFileHint': 'Optional. PDF, Word, Excel or images; up to {max}MB.',
    'staff.contract.signFileSelect': 'Choose file',
    'staff.contract.signFileReplace': 'Replace file',
    'staff.contract.signFileClear': 'Remove file',
    'staff.contract.signFileTooLarge': 'File exceeds {max}MB',
    'staff.contract.signFileInvalidType': 'Unsupported file type',
    'staff.contract.signFileUploadFailed': 'File upload failed, please try again',
    'staff.contract.renew': 'Renew contract',
    'staff.contract.renewConfirm': 'Are you sure you want to renew this contract?',
    'staff.contract.terminate': 'Terminate contract',
    'staff.contract.terminateConfirm':
      'Are you sure you want to terminate this contract? The employee will be suspended.',
    'staff.contract.terminateReason': 'Termination reason',
    'staff.contract.terminateReasonPlaceholder': 'Enter the termination reason',
    'staff.contract.deleteConfirm': 'Are you sure you want to delete this draft contract?',
    'staff.contract.history': 'Contract history',
    'staff.contract.historyEmpty': 'No history for this contract yet.',
    'staff.contract.historyFile': 'Attached document',
    'staff.contract.historyFilePreview': 'View document',
    'staff.contract.historyFileOpen': 'Open in new tab',
    'staff.contract.historyFileDownload': 'Download document',
    'staff.contract.historyFileUnavailable': 'This document is not available for preview.',
    'staff.contract.historyFilePreviewUnsupported':
      'Preview is not supported for this format. Please open or download the document.',
    'staff.contract.documentsTitle': 'Contract documents',
    'staff.contract.documentsLoading': 'Loading documents...',
    'staff.contract.documentsLoadFailed': 'Could not load contract documents.',
    'staff.contract.documentsEmpty': 'No documents have been uploaded for this contract.',
    'staff.contract.documentType.draft': 'Draft document',
    'staff.contract.documentType.signed': 'Signed document',
    'staff.contract.documentType.addendum': 'Contract addendum',
    'staff.contract.documentType.termination': 'Termination document',
    'staff.contract.eventTypes.created': 'Created',
    'staff.contract.eventTypes.sent': 'Sent for approval',
    'staff.contract.eventTypes.approved': 'Approved',
    'staff.contract.eventTypes.rejected': 'Rejected',
    'staff.contract.eventTypes.signed': 'Signed',
    'staff.contract.eventTypes.renewed': 'Renewed',
    'staff.contract.eventTypes.terminated': 'Terminated',
    'staff.contract.eventTypes.updated': 'Updated',
    'staff.contract.status.all': 'All',
    'staff.contract.status': 'Status',
    'staff.contract.status.DRAFT': 'Draft',
    'staff.contract.status.PENDING_APPROVAL': 'Pending approval',
    'staff.contract.status.APPROVED': 'Approved',
    'staff.contract.status.REJECTED': 'Rejected',
    'staff.contract.status.PENDING_SIGNATURE': 'Pending signature',
    'staff.contract.status.SIGNED': 'Signed',
    'staff.contract.status.CANCELLED': 'Cancelled',
    'staff.contract.status.EXPIRED': 'Expired',
    'staff.contract.status.TERMINATED': 'Terminated',
    'staff.contract.errors.notTerminable':
      'Only the latest contract that has not been renewed can be terminated.',
    'staff.contract.errors.notRenewable': 'This contract cannot be renewed.',
    'staff.contract.types.title': 'Contract type management',
    'staff.contract.types.create': 'Add contract type',
    'staff.contract.types.edit': 'Update contract type',
    'staff.contract.types.notifications.createSuccess': 'Contract type added successfully.',
    'staff.contract.types.notifications.updateSuccess': 'Contract type updated successfully.',
    'staff.contract.types.notifications.deleteSuccess': 'Contract type deleted successfully.',
    'staff.contract.types.notifications.deleteFailed': 'Failed to delete contract type.',
    'staff.contract.types.code': 'Contract type code',
    'staff.contract.types.codeHint': 'Leave blank to generate CTT001 automatically',
    'staff.contract.types.name': 'Contract type name',
    'staff.contract.types.description': 'Description',
    'staff.contract.types.term': 'Duration',
    'staff.contract.types.month': 'month',
    'staff.contract.types.months': 'months',
    'staff.contract.types.duration': 'Default duration (months)',
    'staff.contract.types.indefinite': 'Indefinite term',
    'staff.contract.types.active': 'Active',
    'staff.contract.typeStatus.active': 'Active',
    'staff.contract.typeStatus.inactive': 'Inactive',
    'staff.contract.types.status': 'Status',
    'staff.contract.types.sortOrder': 'Sort order',
    'staff.contract.types.filterSearch': 'Search code or name',
    'staff.contract.types.filterSearchPlaceholder': 'Enter contract type code or name',
    'staff.contract.types.termIndefinite': 'Indefinite',
    'staff.contract.types.termFixed': 'Fixed term',
    'staff.contract.types.actions': 'Actions',
    'staff.contract.types.deleteConfirm': 'Are you sure you want to delete this contract type?',
    'staff.contract.types.inUse': 'A contract type in use cannot be deleted.',
    'staff.contract.types.inUseNamed': 'Contract type {name} is in use.',
  },
}
